module.exports = __webpack_public_path__ + "static/media/show-icon.7ec70311.svg";